const API = process.env.REACT_APP_API;

export const env = {
  API,
};
